export const SET_SUMMARIES = "SET_SUMMARIES";
export const SET_IS_FETCHING_DATA = "SET_FETCHING_DATA";
export const SET_IS_FETCHING_INVOICE_SUMMARY =
  "SET_IS_FETCHING_INVOICE_SUMMARY";
export const SET_EVENTS = "SET_EVENTS";
export const SET_FILTERS = "SET_FILTERS";
export const SET_ORGANISATION_SUMMARY = "SET_ORGANISATION_SUMMARY";
export const SET_INVOICE_SUMMARY = "SET_INVOICE_SUMMARY";
